import ApiClient from '@/services/apiClient';
import moment from 'moment';

export default class Intervention {
    id;
    email;
    company_name;
    facility_id;
    facility_name;
    validity_start;
    validity_end;
    note;
    is_external;

    constructor() {
        this.facility_id = "";
    }

    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Intervention();
            obj.id = ApiClient.convertToType(data['id'], 'Integer');
            obj.email = ApiClient.convertToType(data['email'], 'String');
            obj.company_name = ApiClient.convertToType(data['company_name'], 'String');
            obj.facility_id = ApiClient.convertToType(data['facility_id'], 'Integer');
            obj.facility_name = ApiClient.convertToType(data['facility_name'], 'String');
            obj.validity_start = ApiClient.convertToType(data['validity_start'], 'Date');
            obj.validity_end = ApiClient.convertToType(data['validity_end'], 'Date');
            obj.note = ApiClient.convertToType(data['note'], 'String');
            obj.is_external = ApiClient.convertToType(data['is_external'], 'Boolean');
        }
        return obj;
    }

    toJSON() {
      const json = {
        id: this.id,
        email: this.email,
        company_name: this.company_name,
        facility_id: this.facility_id,
        facility_name: this.facility_id,
        validity_start: this.validity_start,
        validity_end: this.validity_end,
        is_external: this.is_external,
      };

      if(this.note) {
        json.note = this.note;
      }

      return json;
    }

    clone() {
        return Intervention.constructFromObject(this);
    }

    get formattedStart() {
        if (!this.validity_start) return '-';
        return `${moment(this.validity_start).format('DD/MM/YYYY HH:mm')}`;
    }

    get formattedEnd() {
        if (!this.validity_end) return '-';
        return `${moment(this.validity_end).format('DD/MM/YYYY HH:mm')}`;
    }

    get isActive() {
        const now = new Date();
        return this.validity_start <= now && now <= this.validity_end;
    }
}
